import { writable } from "svelte/store";

export enum CashMode
{
    Normal,
    Sweeps
}

export enum CashModeString
{
    Cashable = "Cashable",
    Noncashable = "Noncashable"
}
export interface Currency
{
    Prefix: string;
    Suffix: string;
}

export interface IReadOnlyCashierSettings
{
    CashMode: CashMode;
    CashableName: string;
    NoncashableName: string;
    Currency: Currency;
}

const defaultSettings: IReadOnlyCashierSettings = 
{
    CashMode: CashMode.Normal,
    CashableName: "Cashable",
    NoncashableName: "Noncashable",
    Currency: {Prefix: "", Suffix: ""}
}

export const settings = writable<IReadOnlyCashierSettings>(defaultSettings);

// export async function SettingsStartup(firstStartup: boolean)
// {
//     RefreshSettings();

//     if (!firstStartup) return;

//     service.cashierapi.registerOperation("SettingsChanged", "SettingsChanged", SettingsChanged);
// }

// export async function RefreshSettings()
// {
//     let s = await service.cashierapi.settings();
//     settings.set(s);
// }

// export async function SettingsChanged(s: IReadOnlyCashierSettings)
// {
//     console.log("Settings changed", s);
//     settings.set(s);
// }
